const PERMISSION_KEY= "personalize:nebula_metadata";
const PAGE_URL = {
    NEBULA_METADATA_PAGE: "/admin/personalize/nebula-metadata"
}

export {PERMISSION_KEY, PAGE_URL}

